import Vue from 'vue';
import router from './index';
import store from '../store';
import { getStorage } from '@/tools/storage';
import breadcrumb from '@/tools/breadcrumb.js';
// 进度条
// import NProgress from 'nprogress'  progress bar
// import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/tools/auth'; // getToken from cookie
const _import = require('./_import_production');

// NProgress.configure({ showSpinner: false })// NProgress Configuration

// permissiom guide function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true;
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

function guide(next, store, to) {
  const userInfo = getStorage('user|detail');
  if (userInfo) {
    store.commit('SET_INFO', userInfo);
  } else {
    localStorage.clear();
    sessionStorage.clear();
    next({
      path: '/login'
    });
    return;
  }

  // let userAuthData = getStorage('userAuthData') // 用户规则
  // 如果不存在则重定向到第一页面
  if (to.matched.length === 0) {
    // store.commit('CHANGEASIDEACTIVE', '首页')
    next({
      path: '/home'
    });
  } else {
    if (
      /home|zone|information|contract|pCenter|download|accountManagement|invoice|dutypaidProof|v3/.test(
        to.path
      )
    ) {
      next();
    } else {
      console.log(store.state.homeProject);
      if (store.state.homeProject.projectType === '') {
        let homeProject = getStorage('homeProject');
        if (homeProject) {
          store.dispatch('setHomeQuery', homeProject).then(res => {
            next();
          });
        } else {
          next({
            path: '/home'
          });
        }
      } else {
        next();
      }
    }
  }
}
const whiteList = ['/login']; // 白名单
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next({
      name: 'login'
    });
    return;
  }
  document.title = to.meta.name || '后台管理';
  breadcrumb(to, store);

  if (getToken()) {
    guide(next, store, to);
    // if(to.path!='/home'&&to.path!='/login'){
    //   if(!localStorage.projectType){
    //     next({path:'/home'})
    //   }else{
    //     next()
    //   }
    // }else{
    //   next()
    // }
    // if (store.getters.getMenusListRoles.length) {
    //   guide(next, store, to)
    // } else {
    //   let userAuthData = getStorage('userAuthData') // 用户规则
    //   if (userAuthData) {
    //     if (to.path == '/login') {
    //       next({path: userAuthData.returnData.usermodel.menus[0].menus[0].menu_url})
    //     } else {
    //       store.dispatch('GetUserRoles', userAuthData).then(res => {
    //         guide(next, store, to)
    //       })
    //     }
    //   } else {
    //     localStorage.clear()
    //     next({path: '/login'})
    //   }
    // }
  } else {
    if (!!~whiteList.indexOf(to.path)) {
      //在免登录白名单，直接进入
      console.log('in whiteList');
      next();
      return;
    }
    if (from.path !== '/login') {
      next({
        path: '/login'
      }); //否则全部重定向到登录页
    }
  }

  //  NProgress.start()  start progress bar
  // if (getToken()) {
  //   /* has token*/
  //   if (to.path === '/login') {
  //     next({ path: '/' })
  //      NProgress.done()
  //   } else {
  //     if (store.getters.roles.length === 0) {  判断当前用户是否已拉取完user_info信息
  //       store.dispatch('GetUserInfo').then(res => {  拉取user_info
  //         const roles = res.data.roles  as: ['editor','develop']
  //         store.dispatch('GenerateRoutes', { roles }).then(() => {  根据roles权限生成可访问的路由表
  //           router.addRoutes(store.getters.addRouters)  动态添加可访问路由表
  //           next({ ...to, replace: true })  hack方法 确保addRoutes已完成 ,
  //         })
  //       }).catch(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           Message.error(' login again')
  //           next({ path: '/login' })
  //         })
  //       })
  //     } else {
  //        没有动态改变权限的需求可直接next()
  //       if (hasPermission(store.getters.roles, to.meta.roles)) {
  //         next()
  //       } else {
  //         next({ path: '/401', replace: true, query: { noGoBack: true }})
  //       }
  //
  //     }
  //   }
  //
  // } else {
  //   /*  no token*/
  //   if (whiteList.indexOf(to.path) !== -1) {  在免登录白名单，直接进入
  //     next()
  //   } else {
  //     next('/login')  否则全部重定向到登录页
  //      NProgress.done()
  //   }
  // }
});

router.afterEach((to, from) => {
  const obj = {
    shence_id: '',
    frompage_name: from.meta.name || '',
    frompage_url: from.fullPath,
    currentpage_name: to.meta.name || '',
    currentpage_url: to.fullPath
  };
  try {
    const {
      user: { id: userId }
    } = getStorage('user|detail'); // 用户规则
    obj.shence_id = `gongye_${userId}`;
    Vue.prototype.$sa.login(userId);
  } catch (e) {
    window.sa.logout(true);
  }
  // 神策公共属性
  Vue.prototype.$sa.registerPage(obj);
  // 浏览轨迹
  Vue.prototype.$sa.re_pageview();
});
